<template>
  <v-form>
    <v-row>
      <v-col
        cols="12"
      >
        <v-card
          class="mx-5 px-5 py-3"
        >
          <v-text-field
            v-model="submission.form_type"
            label="Form Type"
          ></v-text-field>
          <v-text-field
            v-model="submission.form"
            label="Form"
          ></v-text-field>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        v-for="(field, i) in formFields"
        :key="i"
        cols="12"
        class="mx-4 px-10"
      >
        <template
          v-if="field.children"
        >
          <base-material-card>
            <template v-slot:heading>
              {{ field.label }}
            </template>
            <v-row>
              <v-col
                :key="idx"
                v-for="(child, idx) in field.children"
                cols="12"
                md="4"
                class="mx-4 px-10"
              >
                <v-text-field
                  v-model="child.value"
                  readonly
                  :label="child.label"
                ></v-text-field>
              </v-col>
            </v-row>
          </base-material-card>
        </template>
        <template
          v-else
        >
          <v-row>
            <v-col>
              <v-text-field
                v-model="field.value"
                :label="field.label"

                readonly
              ></v-text-field>
            </v-col>
          </v-row>

        </template>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
  // Utilities
  import { mapActions } from 'vuex'

  export default {
    name: 'RawFormResult',

    inheritAttrs: false,

    props: {
      submission: {
        type: Object,
        default: () => ({
          rowkey: undefined,
        }),
      },
    },
    data: function () {
      return {
        currentObject: {},
        snapshotObject: {},
        formMode: '',
        formErrors: [],
        overlayAbsolute: true,
        overlayDisplay: false,
        formPayload: {},
        formFields: [],
      }
    },

    computed: {
      computedItems () {
        return this.items.map(this.mapItem)
      },
    },
    watch: {
      submission: function (val) {
        console.log('Entered Submission watched event')
        // this.formMode = 'read'
      },
      'submission.id': function (val) {
        console.log('Entered Submission.id watched event')
        this.doInit()
      },
    },
    async created () {
      console.log('Entered Created Event')
      try {
        this.doInit()
      } catch (e) {
        console.log(e)
      }
    },
    methods: {
      ...mapActions(['updateHeatTower', 'createCloudTowerConfigMember', 'deleteCloudTowerConfigMember', 'getCloudTowerConfigMembers']),
      doInit () {
        console.log('Firing doInit!', this.submission)
        try {
          this.formPayload = JSON.parse(this.submission.payload)
        } catch (e) {
          this.formPayload = this.submission.payload
        }
        console.log(this.formPayload)
        this.formMode = 'read'
        this.currentObject = { ...this.submission }
        this.snapshotObject = { ...this.submission }
        this.formFields = this.mapFields(this.formPayload)
      },
      mapItem (item) {
        return {
          ...item,
          children: item.children ? item.children.map(this.mapItem) : undefined,
          title: this.$t(item.title),
        }
      },
      mapFields (object) {
        const formFields = []
        for (const property in object) {
          if (typeof object[property] === 'object' && property !== null) {
            const values = this.mapFields(object[property])
            if (values.length > 0) {
              const rowItem = {
                label: property,
                children: values,
              }
              formFields.push(rowItem)
            }
          } else {
            const rowItem = {
              label: property,
              value: object[property],
            }
            formFields.push(rowItem)
            console.log(`${property}: ${object[property]}`)
          }
        }
        return formFields
      },
    },

  }
</script>

<style>
</style>
